import {
  ShaderMaterial,
  MeshPhongMaterial,
  FrontSide,
  SphereGeometry,
  Mesh,
  Vector4,
  Color,
  Vector3
} from 'three';


import fragmentStar      from '../../../shaders/noisesStar/fragment.glsl';
import vertexStar       from '../../../shaders/noisesStar/vertex.glsl';

import fragmentEarth from '../../../shaders/surface_body/earth/fragment.glsl'
import vertexEarth from '../../../shaders/surface_body/earth/vertex.glsl'

import fragmentMoon from '../../../shaders/surface_body/moon/fragment.glsl'
import vertexMoon from '../../../shaders/surface_body/moon/vertex.glsl'

const MaterialCreators = {
neutronstar: () => {
  return new ShaderMaterial({
    uniforms: {
      time:       { value: 0 },
      uPerlin:    { value: null },
      resolution: { value: new Vector4() },
      uColors: {
        value: [
          new Vector3(1.0, 1.0, 1.0),
          new Vector3(153/255, 230/255, 255/255),
          new Vector3(225/255, 200/255, 255/255)
        ]
      }
    },
    vertexShader:   vertexStar,
    fragmentShader: fragmentStar,
    transparent:    true,
    depthWrite:     true,
    depthTest:      true
  });
},

  sun: () => {
    return new ShaderMaterial({
      uniforms: {
        time:       { value: 0 },
        uPerlin:    { value: null },
        resolution: { value: new Vector4()},
        uColors: {
          value: [
            new Vector3(1,     1,     1    ),
            new Vector3(255/255,242/255,217/255),
            new Vector3(255/255,204/255,153/255) ]}
      },

      vertexShader:   vertexStar,
      fragmentShader: fragmentStar,
      transparent:    true,
      depthWrite:     true,
      depthTest:      true
    });
  },
  
earth: (textureLoader, texture, entityInstance) => {
  const baseMat = new ShaderMaterial({
    uniforms: {
      u_dayTexture:          { value: textureLoader.load(texture.map) },
      u_nightTexture:        { value: textureLoader.load(texture.nightmap) },
      u_normalTexture:       { value: textureLoader.load(texture.normalmap) },
      u_specTexture:         { value: textureLoader.load(texture.specularmap) },
      u_cloudTexture:        { value: textureLoader.load(texture.cloudsmap) },
      u_atmosphereColor:     { value: new Color(0x6BAED6) },
      u_atmosphereStrength:  { value: 0.4 },
      u_cloudShadeStrength:  { value: 0.2 },
      u_cloudBrightness:     { value: 0.9 },
      u_cloudOpacity:        { value: 1.0 }
    },
    vertexShader:vertexEarth,
    fragmentShader:fragmentEarth,
    transparent: true,
    depthTest:   true,
    depthWrite:  true
  });
  return baseMat;
},

  venus: (textureLoader, texture, entityInstance) => {
    const baseMat = new MeshPhongMaterial({
      side:       FrontSide,
      map:        textureLoader.load(texture.map),
      bumpScale:  0.5,
      shininess:  0.5,
      alphaTest:  0.5,
      transparent:false,
      depthWrite: true,
      depthTest:  true,
    });
    
    entityInstance.geoAtm = new SphereGeometry(entityInstance.size * 1.01, 64, 64);
    entityInstance.matAtm = new MeshPhongMaterial({
      side:       FrontSide,
      map:        textureLoader.load(texture.atm_map),
      transparent:true,
      depthWrite: true,
      depthTest:  true,
      opacity:    0.8
    });
    entityInstance.meshAtm = new Mesh(entityInstance.geoAtm, entityInstance.matAtm);

    return baseMat;
  },
  
moon: (textureLoader, texture, entityInstance) => {
  const moonMat = new ShaderMaterial({
    uniforms: {
      u_texture: {
        value: textureLoader.load(texture.map)
      },
      u_normalMap: {
        value: textureLoader.load(texture.normal_map)
      }
    },

    vertexShader:vertexMoon,
    fragmentShader:fragmentMoon,

    side:        FrontSide,
    transparent: true,
    depthTest:   true,
    depthWrite:  true
  });

  return moonMat;
},

default: (textureLoader, texture, entityInstance) => {
  if (!texture) return null;
  const {
    map,
    bump_map,
    displac_map,
  } = texture;

  const params = {
    side:          FrontSide,
    bumpScale:     1.0,
    shininess:     0.5,
    alphaTest:     0.5,
    transparent:   true,
    depthTest:     true,
    depthWrite:    true
  };

  if (map) params.map   = textureLoader.load(map);
  if (bump_map) {
    params.bumpMap = textureLoader.load(bump_map);
    if(displac_map){
    params.displacementMap  = textureLoader.load(bump_map);
    params.displacementScale = entityInstance.size*0.1;
    }
  }
  return new MeshPhongMaterial(params);
}

};
export function createMaterial(entityName, textureLoader, texture, entityInstance) {
  const key      = entityName.toLowerCase();
  const creator  = MaterialCreators[key] || MaterialCreators.default;
  return creator(textureLoader, texture, entityInstance);
}
